import { useState } from "react";

export const DISMISS_KEY = "notif_banner_dismissed_until";
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

const permission = () =>
  typeof Notification === "undefined" ? "unsupported" : Notification.permission;

const isDismissed = () => {
  try {
    return Number(localStorage.getItem(DISMISS_KEY)) > Date.now();
  } catch {
    return false;
  }
};

// Asks staff to allow browser alerts. Shows only while the browser has not
// been asked ("default") and staff have not dismissed it in the last 7 days.
const NotificationBanner = () => {
  const [perm, setPerm] = useState(permission);
  const [dismissed, setDismissed] = useState(isDismissed);

  if (perm !== "default" || dismissed) return null;

  const enable = async () => {
    await Notification.requestPermission();
    setPerm(permission());
  };

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now() + SEVEN_DAYS_MS));
    } catch {
      // Private mode: hide for this visit only.
    }
    setDismissed(true);
  };

  return (
    <div className="mb-6 flex items-center justify-between gap-4 rounded-lg border border-amber-400 bg-amber-300 px-4 py-3 shadow-md">
      <div className="flex items-center gap-3">
        <svg
          className="h-6 w-6 flex-shrink-0 text-teal-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        <p className="text-sm text-amber-950">
          <span className="font-bold">Never miss a lead.</span> Get a desktop
          alert when a lead needs a look
          <span className="hidden md:inline">
            , even when this tab is in the background
          </span>
          .
        </p>
      </div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={enable}
          className="rounded-md bg-teal-700 px-7 py-1.5 text-sm font-medium text-white hover:bg-teal-800"
        >
          Enable
        </button>
        <button
          type="button"
          aria-label="Dismiss for 7 days"
          onClick={dismiss}
          className="text-amber-950 hover:text-black"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner;
